import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { SearchDropdownComponent } from '../../../app/courrier/search-dropdown/search-dropdown.component';
import { environment } from '../../../environments/environment';
import { MpsUserService } from '../../services/mps-user.service';
import { MpsFooterComponent } from '../mps-footer/mps-footer.component';
import { MpsHeaderComponent } from '../mps-header/mps-header.component';
import { MpsLoaderComponent } from '../mps-loader/mps-loader.component';

@Component({
  selector: 'mps-app-root',
  templateUrl: './mps-app.component.html',
  styleUrl: './mps-app.component.scss',
  imports: [
    MpsLoaderComponent,
    MpsHeaderComponent,
    MpsFooterComponent,
    TranslateModule,
    RouterOutlet,
    SearchDropdownComponent,
  ],
})
export class MpsAppComponent {
  private translateService = inject(TranslateService);
  private userService = inject(MpsUserService);
  private user = signal(this.userService.getUserSubject().getValue());

  public constructor() {
    this.initTranslationService();
  }

  private initTranslationService() {
    this.translateService.setDefaultLang(environment.defaultLocale);
    this.translateService.addLangs(environment.allowedLanguage);

    // Set a default language if there's no language set
    if (!this.translateService.currentLang) {
      const userLang = this.user()?.lang;
      this.translateService.use(
        userLang && this.translateService.getLangs().includes(userLang)
          ? userLang
          : (localStorage.getItem('lang') as string) || environment.defaultLocale
      );
    }
  }
}
